import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * RITA-1505 (Nutzungserfassung Phase 2c) — ein Abschnitt der Auswertungsseite.
 *
 * Überschrift plus Erläuterung in einem Baustein, weil jeder Abschnitt der Seite eine braucht:
 * die Zahlen sind ohne ihre Regel (was zählt als Sitzung, was heißt „abgeschickt“, warum fehlen
 * Zeilen) nicht richtig zu lesen. Die Erläuterung steht deshalb nicht in der Doku, sondern hier.
 */
export interface AbschnittProps {
  titel: string;
  erlaeuterung?: React.ReactNode;
  children: React.ReactNode;
  /** Kennung für Browser- und Unit-Tests. */
  testId?: string;
}

export default function Abschnitt({ titel, erlaeuterung, children, testId }: AbschnittProps) {
  return (
    <Box component="section" data-testid={testId} sx={{ mt: 4 }}>
      <Typography variant="h6" fontWeight={700} sx={{ mb: erlaeuterung ? 0.5 : 1.5 }}>
        {titel}
      </Typography>
      {erlaeuterung && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5, maxWidth: '80ch' }}>
          {erlaeuterung}
        </Typography>
      )}
      {children}
    </Box>
  );
}
